<template>
	<div class="flex justify-around flex-wrap">
		<slider class="slider" ref="slider" :options="options">
			<slideritem v-for="(item, index) in images" :key="index">
				<img :src="item" alt="" :key="index" :preview="item" />
			</slideritem>
		</slider>
		<div class="content rich-text" v-html="face.content"></div>
	</div>
</template>

<script>
	import { slider, slideritem } from 'vue-concise-slider';
export default {
	components:{
		slider,slideritem
	},
	computed: {
		images() {
			return this.face.images || [this.face.image];
		}
	},
	props: {
		face: Object
	},
	data() {
		return {
			options: {
				currentPage: 0,
				//autoplay: "15000",
				loop: true
			}
		};
	},
	methods: {
		goDetail(id, data = {}) {
			this.$emit('detail', { id: id, data: data });
		}
	}
};
</script>

<style lang="scss" scoped>
.slider {
	width: 5.6rem;
	height: 5.6rem;
	background: #fff;
	border-radius: 0.16rem;
	box-shadow: 0 0.04rem 0.24rem rgba($color: #000000, $alpha: 0.27);
	img {
		width: 90%;
		height: 90%;
	}
	.slider-pagination-bullet-active{
		background: rgba($color: #000000, $alpha: 0.6);
	}
}
.content {
	line-height: 0.4rem;
	font-size: 0.28rem;
	color: #d2d2d2;
	img {
		width: 100% !important;
	}
}
</style>
